import Image from '@components/Image/Image'
import { UserProfile } from 'sdk/services/storage/profiles/types/profilesManager'
import './ProfileIcon.scss'
import { KidsTag } from '../KidsTag/KidsTag'
import { isUserProfile, kidsTagColor } from '@utils/helpers'
import { ProfileImagesData } from 'sdk/services/config/types/config'
import { KidsTagVariant } from '@enums/profile.enum'
import classNames from 'classnames'

interface ProfileIconProps {
  profileData?: UserProfile | ProfileImagesData | null
  profileName?: string
  parentalControl?: string | null
  kidsTagVariant?: KidsTagVariant
}

export const ProfileIcon = ({
  profileData,
  profileName,
  kidsTagVariant,
  parentalControl: parentalControlProp,
}: ProfileIconProps) => {
  if (!profileData) return null

  const parentalControl =
    parentalControlProp ?? (isUserProfile(profileData) ? profileData.parentalControl?.contentClassification : null)

  const imageData: ProfileImagesData = isUserProfile(profileData) ? profileData.image : profileData
  const userName = isUserProfile(profileData) ? profileData.name : null
  const imageType = isUserProfile(profileData) ? profileData.image.type : null

  return (
    <div className={classNames('profile-icon', imageType)}>
      {imageData?.url ? (
        <Image image={imageData.url} bgColor={imageData.backgroundColor} fallbackOnLoad={false} />
      ) : (
        <div className="profile-image-letter" style={{ color: imageData?.color }}>
          {userName?.charAt(0) || profileName?.charAt(0)}
        </div>
      )}
      {parentalControl && <KidsTag color={kidsTagColor(profileData)} variant={kidsTagVariant} />}
    </div>
  )
}
